export const errorCodeToMessage = (code) => {
  switch (code) {
    case 400: return "missingOrInvalidRequestParameters";
    case 401: return "authorizationRequired";
    case 404: return "unknownObjectID";
    default:  return "anErrorOccuredPleaseTryAgainLater";
  }
}
